import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#F8931F',
    },
    secondary: {
      main: '#41210A',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
